<script>
export default {
    props: {
        entries: {
            type: Array,
            default() {
                return [];
            },
        },
        title: {
            type: String,
            default: '',
        },
    },
}
</script>
<template>
    <div class="aktion-quiz-leaderboard">
        <h3 class="aktion-quiz-leaderboard__title" v-if="title">{{ title }}</h3>
        <p class="aktion-quiz-leaderboard__empty" v-if="!entries || entries.length === 0">
            No scores yet — be the first to make the board!
        </p>
        <table class="aktion-quiz-leaderboard__table" v-else>
            <thead>
                <tr>
                    <th>Rank</th>
                    <th>Player</th>
                    <th>First</th>
                    <th>Best</th>
                    <th>Most Recent</th>
                    <th>Attempts</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="entry in entries" :key="entry.rank + '-' + entry.user_id">
                    <td>{{ entry.rank }}</td>
                    <td>{{ entry.display_name }}</td>
                    <td>{{ entry.first_score }} / {{ entry.first_max }}</td>
                    <td>{{ entry.best_score }} / {{ entry.best_max }}</td>
                    <td>{{ entry.recent_score }} / {{ entry.recent_max }}</td>
                    <td>{{ entry.attempts }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>
